export default "__VITE_ASSET__zlQ$EwpX__"